import React from 'react';
import {ModalDangerButtons, Modal} from 'components/modals';
import {observer} from 'mobx-react';
import {TextArea} from 'components';
import {FormattedMessage} from 'react-intl';

const PromptModal = ({isOpen, uiState}) => {
  const {editingPrompt, position, monthlyUsageRemaining, promptErrors} = uiState;

  return (
    <Modal
      size='md'
      title='recruiting.hiring_funnel.AI Screener'
      onHide={() => uiState.closePromptModal()}
      isOpen={isOpen}
    >
      <TextArea
        label='Prompt'
        value={editingPrompt.text}
        onChange={(e) => editingPrompt.merge({text: e.target.value})}
        placeholder='recruiting.hiring_funnel.e.g. Has at least 2 years of experience in software development'
        minRows={5}
        errorMessage={promptErrors.text}
      />
      <div className='waterloo'>
        <FormattedMessage
          id={monthlyUsageRemaining < 1000 ? 'recruiting.hiring_funnel.CANDIDATE_ESTIMATE_WITH_USAGE' : 'recruiting.hiring_funnel.CANDIDATE_ESTIMATE'}
          values={{
            count: position.activeCandidateCount,
            monthlyUsageRemaining: monthlyUsageRemaining
          }}
        />
      </div>
      <div className='jumbo mt1'>
        <FormattedMessage 
          id='recruiting.hiring_funnel.OPENAI_DISCLAIMER'
          values={{ privacyLink: <a href="https://openai.com/policies/privacy-policy" target="_blank"><FormattedMessage id='recruiting.hiring_funnel.privacy policy'/></a> }}
        />
      </div>
      <ModalDangerButtons
        saveCaption='recruiting.hiring_funnel.Run Prompt'
        onCancel={() => uiState.closePromptModal()}
        onSave={() => uiState.runPrompt()}
      />
    </Modal>
  );
};

export default observer(PromptModal);
